// extracted by mini-css-extract-plugin
export default {"message":"message_message__0ul7g","success":"message_success__CQ1qC","error":"message_error__ptUTq","show":"message_show__pGFvg"};